import BlurLinearOutlined from "@mui/icons-material/BlurLinearOutlined";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Calendar } from "../../../../../styles/icons/calendar";
import { makeDefaultFilters } from "../../../../../utils/default-filters";
import { BetaBadge } from "../../../../generic/components/beta/beta-badge";
import { useIsActive } from "../hooks/use-is-active";
import { Item } from "../item";
import { Section } from "../section";

export const NavPlannerOptions: FC = () => {
  const { t } = useTranslation();

  const isActive = useIsActive();

  const filters = makeDefaultFilters().toString();

  return (
    <Section title={t("Planner")}>
      <>
        <BetaBadge overlap="circular" sx={{ "& .MuiBadge-badge": { top: "18px" } }}>
          <Item
            title={t("Calendar")}
            icon={<Calendar />}
            onClick={{ type: "href", value: `/calendars/schedule?${filters}` }}
            active={isActive("/calendars")}
          />
        </BetaBadge>
        <Item
          title={t("Timeline")}
          icon={<BlurLinearOutlined />}
          onClick={{ type: "href", value: `/timeline/start_date?${filters}` }}
          active={isActive("/timeline", true)}
        />
      </>
    </Section>
  );
};
